import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "search",
    component: () => import("./views/SearchView.vue"),
    meta: { navLabel: "Search" }
  },
  {
    path: "/saved",
    name: "saved",
    component: () => import("./views/SavedView.vue"),
    meta: { navLabel: "Saved", requiresAuth: true }
  },
  {
    path: "/favorites",
    name: "favorites",
    component: () => import("./views/FavoritesView.vue"),
    meta: { navLabel: "Favorites" }
  },
  {
    path: "/account",
    name: "account",
    component: () => import("./views/AccountView.vue"),
    meta: { navLabel: "Account", requiresAuth: true }
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("./views/AdminView.vue"),
    meta: {
      navLabel: "Admin",
      hideChrome: true,
      headerTitle: "Operate the ranking system.",
      headerBody: "Admin access now lives in the app shell using the existing admin API."
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
